import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Building2, FileText, KanbanSquare, Package, LogOut, Cog } from "lucide-react";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/aziende", label: "Contatti", icon: Building2, id: "aziende" },
  { to: "/offerte", label: "Offerte", icon: FileText, id: "offerte" },
  { to: "/pipeline", label: "Pipeline", icon: KanbanSquare, id: "pipeline" },
  { to: "/catalogo", label: "Catalogo Attuatori", icon: Package, id: "catalogo" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <aside className="w-64 shrink-0 bg-[#0A192F] text-white flex flex-col fixed h-screen z-20">
        <div className="px-6 py-6 border-b border-white/10 flex items-center gap-3">
          <div className="w-9 h-9 bg-[#0052CC] rounded-sm flex items-center justify-center">
            <Cog className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display font-black text-lg leading-none tracking-tight">LINEARCRM</div>
            <div className="font-mono-label text-[9px] text-slate-400 mt-1">ATTUATORI LINEARI</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-6 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-[#0052CC] text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <n.icon className="w-[18px] h-[18px]" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-xs text-slate-400 truncate">{user?.email}</div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={() => { logout(); navigate("/login"); }}
            className="flex w-full items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium text-slate-300 hover:bg-white/5 hover:text-white transition-colors duration-200"
          >
            <LogOut className="w-[18px] h-[18px]" /> Esci
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
